export const DADATA_TOKEN = process.env.REACT_APP_DADATA_TOKEN;
export const API_URL = process.env.REACT_APP_API_URL;
export const YANDEX_METRIKA_ID = process.env.REACT_APP_YANDEX_METRIKA_ID;
export const GET_MAP_CENTER = API_URL + "map-center/";
// Бугульма — опорный город сервиса. Используется, пока не пришёл центр с сервера
// (map-center/) или координаты водителя. Раньше здесь был Санкт-Петербург, из-за чего
// карта на старте показывала чужой город.
export const DEFAULT_CENTER_POSITION = [54.5366, 52.7974];
export const NOMINATIM_URL = "https://nmtaxibot.site/nomination";
